import { registerModule } from '../shell';
import { loadRemoteModule } from './loadRemote';
// By conventions, the remote:
//    - filename is always: "remoteEntry.js"
//    - only a single module called "./register" is exposed
const EntryPoint = 'remoteEntry.js';
const newGuid = () => 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, _ => ((Math.random() * 16) | 0).toString(16));
export let registrationStatus = 'none';
export async function getRemotePromise(remote, remotes, runtime, context, index, errors = [], cancelRequest = undefined) {
    const remoteUrl = new URL(`${EntryPoint}\?${newGuid()}`, remote.url).toString();
    const containerName = remote.name;
    for (let i = 0; i < remote.modules.length; i++) {
        const moduleName = remote.modules[i];
        const modulePath = `./${moduleName}`;
        try {
            runtime.logger.information(`[shell] ${index + 1}/${remotes.length} Loading module "${moduleName}" from container "${containerName}" of remote "${remoteUrl}"`);
            const module = await loadRemoteModule(remoteUrl, containerName, modulePath, undefined, cancelRequest);
            if (!module[moduleName] && !module.default) {
                throw new Error(`[shell] A ${moduleName} function is not available for module "${moduleName}" of container "${containerName}" from remote "${remoteUrl}". Make sure your remote "./${moduleName}.js" file export a function named "${moduleName}"`);
            }
            runtime.logger.information(`[shell] ${index + 1}/${remotes.length} Registering module "${moduleName}" from container "${containerName}" of remote "${remoteUrl}"`);
            await registerModule(module.default ?? module[moduleName], runtime, context);
            runtime.logger.information(`[shell] ${index + 1}/${remotes.length} container "${containerName}" of remote "${remoteUrl}" registration completed"`);
            return Promise.resolve();
        }
        catch (error) {
            runtime.logger.error(`[shell] An error occured while registering module "${moduleName}" from container "${containerName}" of remote "${remoteUrl}"`, error);
            errors.push({
                url: remoteUrl,
                containerName,
                moduleName: moduleName,
                error,
            });
            return Promise.reject(error);
        }
    }
}
export async function registerRemoteModules(remotes, runtime, { context } = {}) {
    const errors = [];
    runtime.logger.information(`[shell] Found ${remotes.length} remote module${remotes.length > 1 ? 's' : ''} to register`);
    registrationStatus = 'in-progress';
    const remotePromises = [];
    for (const remote of remotes) {
        remotePromises.push(() => getRemotePromise(remote, remotes, runtime, context, remotes.indexOf(remote), errors));
    }
    const remoteResults = await Promise.allSettled(remotePromises.map(x => x()));
    registrationStatus = 'ready';
    return { registrationErrors: errors, remotesForRetry: getFailedRemotePromises(remotes, remoteResults) };
}
function getFailedRemotePromises(remotes, promiseResults) {
    return remotes.filter((x, index) => promiseResults[index].status === 'rejected');
}
